const GET = async ({ params, fetch }) => {
  let version = params.version;
  if (version === "latest") {
    const response2 = await fetch("/releases/latest");
    const release = await response2.json();
    version = release.tag_name;
  }
  const tag = version.replace("v", "");
  const response = await fetch(
    `https://github.com/carlelieser/glimmr-release/releases/download/${version}/glimmr-${tag}-setup.exe`
  );
  return new Response(response.body);
};
export {
  GET
};
